import request from '@/utils/request'

/**
 * 充值页面数据
 *
 * @export
 * @returns
 */
export function rechargePageData() {
  return request({
    url: '/Api/Personal/Recharge/PageData',
    method: 'post'

  })
}

/**
 * 已兑换-充值记录
 *
 * @param {*} kw 充值时间/金额
 * @param {*} pageIndex 当前页
 * @param {*} pageSize 每页大小
 * @export
 * @returns
 */
export function rechargeList({ kw, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Recharge/List?kw=${kw}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'

  })
}

/**
 * 推广用户列表
 * @param {Number} amountId 充值金额Id
 * @param {Number} paymentType 支付类型Id
 * @param {*} tradeType 交易类型Id
 * @param {*} code 微信授权码
 * @export
 * @returns
 */
export function pay({ amountId, paymentType, tradeType, code }) {
  return request({
    url: `/Api/Personal/Recharge/Pay?amountId=${amountId}&paymentType=${paymentType}&tradeType=${tradeType}&code=${code}`,
    method: 'post'

  })
}

/**
 * 发送原手机号验证码
 * @param {*} phone 原手机号
 * @export
 * @returns
 */
export function sendOldCode(phone) {
  return request({
    url: `/Api/Personal/Settings/SendOldCode?phone=${phone}`,
    method: 'post'
  })
}

/**
 * 发送新手机号验证码
 * @param {*} phone 新手机号
 * @export
 * @returns
 */
export function sendNewCode(phone) {
  return request({
    url: `/Api/Personal/Settings/SendNextCode?phone=${phone}`,
    method: 'post'
  })
}

/**
 * 验证原手机号验证码
 * @param {*} phone 原手机号
 * @param {*} code 原手机号验证码
 * @export
 * @returns
 */
export function validateOldCode(phone, code) {
  return request({
    url: `/Api/Personal/Settings/ValidateOldCode?phone=${phone}&code=${code}`,
    method: 'post'
  })
}

/**
 * 验证新手机号验证码
 * @param {*} phone 新手机号
 * @param {*} code 新手机号验证码
 * @export
 * @returns
 */
export function editPhone(phone, code) {
  return request({
    url: `/Api/Personal/Settings/EditPhone?phone=${phone}&code=${code}`,
    method: 'post'
  })
}

/**
 * 未兑换-充值记录
 *
 * @export
 * @returns
 */
export function notRedeemed() {
  return request({
    url: '/Api/Personal/Recharge/NotRedeemed',
    method: 'post'
  })
}

/**
 * 兑换消费币
 * @param {*} no 重置订单编号
 * @param {*}
 * @export
 * @returns
 */
export function convertMoney(no) {
  return request({
    url: `/Api/Personal/Recharge/ConvertMoney?orderno=${no}`,
    method: 'post'
  })
}

/**
 * 兑换记录
 * @param {*} kw 关键词
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  分页大小
 * @export
 * @returns
 */
export function convertMoneyRecord({ kw, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Recharge/ConvertMoneyRecord?kw=${kw}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}

/**
 * 消费币明细
 * @param {*} kw 关键词
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  分页大小
 * @export
 * @returns
 */
export function currencyDetail({ sd, ed, st, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Recharge/CurrencyDetail?sd=${sd}&ed=${ed}&st=${st}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}

/**
 * 消费记录
 * @param {*} kw 关键词
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  分页大小
 * @export
 * @returns
 */
export function expenseRecord({ sd, ed, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Recharge/ExpenseRecord?sd=${sd}&ed=${ed}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}

/**
 * 通话记录
 * @param {*} kw 关键词
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  分页大小
 * @export
 * @returns
 */
 export function callRecord({ kw, pageIndex, pageSize }) {
  return request({
    url: `/Api/call/getPage?keyword=${kw}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'get'
  })
}

/**
 * 获取充值订单支付状态
 * @export
 * @returns
 */
// eslint-disable-next-line camelcase
export function payStatus(out_trade_no) {
  return request({
    // eslint-disable-next-line camelcase
    url: `/Api/Personal/Recharge/PayStatus?out_trade_no=${out_trade_no}`,
    method: 'post'
  })
}
